import { useState, useEffect, useContext, useRef } from "react";
import buildLink from "../urls";
import _axios from "../axios";
import { useReactToPrint } from "react-to-print";
import { FaEye } from "react-icons/fa";
import { AiOutlinePrinter } from "react-icons/ai";
import SingleProducts from "../components/SingleProduct";
import SingleProductOnlyImage from "../components/SingleProductOnlyImage";
import Loader from "../components/Loader";
import VerticalNav from "../components/VerticalNav";
import noorders from "../../src/assets/images/no_orders.png";
import DotsLoader from "../components/DotsLoader";
import ReactPaginate from "react-paginate";
import { AccountContext } from "../contexts/AccountContext";
import { useNavigate } from "react-router-dom";
import { BsSearch } from "react-icons/bs";
import PopUp from "../components/Popup";
import OrderProduct from "../components/OrderProduct";
import Select from 'react-select';
import OrderInfo from "../components/OrderInfo";

export default function PosOrders() {
  const [loading, setLoading] = useState(false);
  const [stateAccount, dispatchAccount] = useContext(AccountContext);
  const [holdArray, setHoldArray] = useState([]);
  const searchInput = useRef(null);
  const [showDetails, setShowDetails] = useState();
  const [totalPages, setTotalPages] = useState(0);
  const [details, setDetails] = useState();
  const [holdDetails, setHoldDetails] = useState();
  const refinputdate = useRef(null);
  const [date, setDate] = useState();
  const [totals, setTotals] = useState("");
  const [orderStatus, setOrderStatus] = useState({ value: "all", label: "All" });
  const [error, setError] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [orders, setOrders] = useState([]);
  const width = window.innerWidth;
  const navigate = useNavigate();


  const options = [
    { value: "all", label: "All" },
    { value: "processing", label: "Processing" },
    { value: "complete", label: "Completed" },
    { value: "trash", label: "Canceled" },
  ];

 

  const handleStatusChange = (selectedOption) => {
    setOrderStatus(selectedOption);
  };

  const changeNavStatus = (value) => {
    const allOption = options.find(option => option.value === value);
    setOrderStatus(allOption);
  };


  useEffect(() => {
    _axios
      .get(buildLink("get_account", undefined, window.innerWidth))
      .then((response) => {
        if (!response.data.success) {
          dispatchAccount({ type: "setLoading", payload: false });
          if (!stateAccount.loading && !stateAccount.loged) {
            navigate("/");
          }
        }
      });
  }, [window.location.href]);

  useEffect(() => {
    fetchOrders(1);
  }, []);

  const fetchOrders = async (currentPage = 1) => {
    setLoading(true);
    try {
      const skuValue = searchInput?.current?.value || "";
      const dateValue = refinputdate?.current?.value || "";
      

      const resp = await _axios.get(
        buildLink("orders") +
          `&status=${orderStatus?.value}&page=${currentPage}&limit=20&filter_order_product_sku=${skuValue}&filter_date=${dateValue}`
      );

      if (resp.data.data.orders) {
        setTotalPages(resp.data.data.meta.total_pages);
        setOrders(resp.data.data.orders);
      } else {
        setOrders([]);
        setTotalPages(0);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  function handlePrint(id) {
    const url = "/posprint/" + id;

    const windowFeatures =
      " toolbar=no, location=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=302.36220472441, height=250";

    window.open(url, "_blank", windowFeatures);
  }

  useEffect(() => {
    var d = new Date(),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    const date = [year, month, day].join("-");
    setDate(date);
    // getOrders(date);
  }, [window.location]);

  function print() {
    const url = "/ordersprint/";

    const windowFeatures =
      " toolbar=no, location=no, status=no, menubar=no, scrollbars=yes, resizable=yes";

    window.open(url, "", windowFeatures);
  }

  useEffect(() => {
    // Load the array from local storage on component mount
    const storedHold = localStorage.getItem("hold-order");
    // console.log(JSON.parse(storedHold));
    if (storedHold) {
      setHoldArray(JSON.parse(storedHold));
    }
  }, [window.location]);

  const detailsShow = (value) => {
    setHoldDetails("");
    setShowDetails(true);
    var sum = 0;
    const orderId = value;
    const url = buildLink("order_details") + `${orderId}`;
    if (date !== undefined) {
      _axios
        .get(url)
        .then((response) => {
          if (response.data.success) {
            const orderDetails = response.data.data;
            if (Array.isArray(orderDetails.products)) {
              setDetails(orderDetails);
            }
          }
          setTotals(sum);
        })
        .catch((error) => {
          console.error("Error fetching orders:", error);
        });
    }
  };

  const handlePageClick = (pageselected) => {
    const page = parseInt(pageselected.selected) + 1;
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  function detailsHoldShow(value) {
    setDetails("");
    setShowDetails(value);
    setHoldDetails(holdArray[value]);
  }

  useEffect(() => {
    fetchOrders(currentPage);
  }, [orderStatus, currentPage]);

  useEffect(() => {
    // Save the array to local storage whenever it changes
    localStorage.setItem("hold-order", JSON.stringify(holdArray));
  }, [holdArray]);

  return (
    <div className="flex flex-col md:flex-row min-h-screen">
      <nav className="w-64 bg-dborderblack1 text-white  flex-col p-4 hidden md:flex">
        <button
          onClick={() => changeNavStatus("all")}
          className={`mb-4 p-2 rounded ${
            orderStatus?.value === "all" &&
            "bg-white border-blue-800 text-dborderblack1"
          }`}
        >
          All Order
        </button>
        <button
          onClick={() => changeNavStatus("processing")}
          className={`mb-4 p-2 rounded ${
            orderStatus?.value === "processing" &&
            "bg-white border-blue-800 text-dborderblack1"
          }`}
        >
          Processing Orders
        </button>
        <button
          onClick={() => changeNavStatus("complete")}
          className={`mb-4 p-2 rounded ${
            orderStatus?.value === "complete" &&
            "bg-white border-blue-800 text-dborderblack1"
          }`}
        >
          Completed Orders
        </button>
        <button
          onClick={() => changeNavStatus("trash")}
          className={`mb-4 p-2 rounded ${
            orderStatus?.value === "trash" &&
            "bg-white border-blue-800 text-dborderblack1"
          }`}
        >
          Canceled Orders
        </button>
      </nav>

      <div className={`bg-dgrey10 pt-5 w-full`}>
        <div className="flex flex-col md:flex-row items-center justify-between md:mb-6 px-4 py-2 border-b border-gray-300">
          <h3 className="text-2xl font-semibold text-dborderblack1 mb-2 md:mb-0">
            Orders Page
          </h3>


            <form
              onSubmit={(e) => {
                e.preventDefault();
                fetchOrders();
              }}
              className="relative border border-[#d5d5d5] text-left w-full lg:w-[30%] sm:w-[45%] bg-[#e7e7e7] bg-opacity-25  lg:px-0 px-1 rounded-lg flex items-center sm:mb-0 mb-4"
            >
              <input
                placeholder="Order ID or Product Name or SKU"
                ref={searchInput}
                className=" w-full lg:py-2 py-2 pl:2 text-xs md:text-sm md:pl-4  bg-transparent outline-none"
              />
              <button
                type="submit"
                className="hover:bg-dbase1 h-full rounded-md px-4 md:px-3 absolute right-0 top-0 text-lg text-dborderblack1"
              >
                <BsSearch className="text-xl md:text-lg" />
              </button>
            </form>


            


        <div className="flex items-center justify-between w-full md:w-fit gap-3">
          <div className=" flex flex-row sm:flex-row gap-3 justify-center lg:py-1 sm:justify-start w-1/2 md:w-fit  sm:w-auto lg:px-3 px-4  border border-[#D5D5D5] bg-[#E7E7E7] bg-opacity-25 rounded-lg">
            <div className="items-center text-sm hidden md:flex ">Date:</div>
              <input
                onChange={() => fetchOrders(currentPage)}
                ref={refinputdate}
                type="date"
                className="border-none outline-none lg:py-1 py-2 bg-transparent text-sm w-full sm:w-auto"
                placeholder="Fiter By Date"
              />
          </div>
          <Select
            placeholder="Select Order Type"
            className="w-1/2 text-base md:hidden"
            options={options}
            value={orderStatus}
            onChange={handleStatusChange}
          />
        </div>
        </div>

        {!orders ? (
          <Loader />
        ) : orders?.length === 0 && holdArray?.length === 0 ? (
          <div className="flex mt-2 gap-5 min-h-[40vh]">
            {/* {window.innerWidth > 650 && (
              <div className="w-1/2">
                <VerticalNav />
              </div>
            )} */}
            <div className="flex flex-col justify-center items-center w-full">
              <img
                src={noorders}
                alt="No orders available"
                className="w-1/2 h-1/2 object-contain"
              />
              <p className="font-bold text-blue-500 capitalize">
                no orders found
              </p>
            </div>
          </div>
        ) : (
          <>
            {loading ? (
              <h1>loading</h1>
            ) : (
              <div className="w-full flex-col p-5 hidden md:flex">
                <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
                  <div className="inline-block min-w-full py-4 sm:px-6 lg:px-8">
                    <div className="overflow-x-auto shadow-md rounded-lg">
                      <table className="min-w-full text-left font-medium bg-white">
                        <thead className="bg-gray-100 text-gray-700 text-sm uppercase border-b border-gray-300">
                          <tr>
                            <th scope="col" className="px-6 py-4 w-1/12">
                              Order ID
                            </th>
                            <th scope="col" className="px-6 py-4 w-2/12">
                              Customer Name
                            </th>
                            <th scope="col" className="px-6 py-4 w-2/12">
                              Number of Products
                            </th>
                            <th scope="col" className="px-6 py-4">
                              Status
                            </th>
                            <th scope="col" className="px-6 py-4">
                              Date
                            </th>
                            <th scope="col" className="px-6 py-4 w-1/12">
                              Total
                            </th>
                            <th scope="col" className="px-6 py-4 text-center">
                              Order Details
                            </th>
                          </tr>
                        </thead>

                        <tbody>
                          {orders?.length > 0 &&
                            orders.map((order) => (
                              <tr
                                key={order.order_id}
                                className="border-b hover:bg-gray-100"
                              >
                                <td className="whitespace-nowrap px-6 py-4">
                                  {order?.order_id}
                                </td>
                                <td className="whitespace-nowrap px-6 py-4">
                                  {order?.name}
                                </td>
                                <td className="whitespace-nowrap px-6 py-4">
                                  {order?.products}
                                </td>
                                <td className="whitespace-nowrap px-6 py-4">
                                  {order?.status_group}
                                </td>
                                <td className="whitespace-nowrap px-6 py-4">
                                  {order?.date_added}
                                </td>
                                <td className="whitespace-nowrap px-6 py-4">
                                  {order?.total}
                                </td>
                                <td className="whitespace-nowrap px-6 py-4 text-center">
                                  <button
                                    className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-3 rounded-full mr-2"
                                    onClick={() => detailsShow(order?.order_id)}
                                  >
                                    <FaEye />
                                  </button>
                                </td>
                              </tr>
                            ))}

                          {holdArray?.length > 0 &&
                            holdArray.map((order, key) => (
                              <tr
                                key={key}
                                className="border-b bg-gray-50 hover:bg-gray-100"
                              >
                                <td className="whitespace-nowrap px-6 py-4">
                                  Hold
                                </td>
                                <td className="whitespace-nowrap px-6 py-4">
                                  {order?.firstname}{" "}
                                  {order?.lastname !== "Local Customer" &&
                                    order?.lastname}
                                </td>
                                <td className="whitespace-nowrap px-6 py-4">
                                  {order?.telephone}
                                </td>
                                <td className="whitespace-nowrap px-6 py-4">
                                  {order?.sub_total}
                                </td>
                                <td className="whitespace-nowrap px-6 py-4">
                                  {order?.modification_amount}
                                </td>
                                <td className="whitespace-nowrap px-6 py-4">
                                  {order?.coupon}
                                </td>
                                <td className="whitespace-nowrap px-6 py-4 text-center">
                                  <button
                                    className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-3 rounded-full mr-2"
                                    onClick={() => detailsHoldShow(key)}
                                  >
                                    <FaEye />
                                  </button>

                                  <button
                                    className="bg-green-500 hover:bg-green-600 text-white font-semibold py-2 px-3 rounded-full"
                                    onClick={() => handlePrint(key)}
                                  >
                                    <AiOutlinePrinter />
                                  </button>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {totalPages > 1 && (
              <div className="h-12 my-5">
                <ReactPaginate
                  className={"category-pagination"}
                  breakLabel="..."
                  nextLabel=">"
                  onPageChange={handlePageClick}
                  pageRangeDisplayed={width < 650 ? 1 : 2}
                  marginPagesDisplayed={width < 650 ? 1 : 2}
                  pageCount={totalPages}
                  previousLabel="<"
                  activeClassName={"active-pagination-category"}
                  renderOnZeroPageCount={null}
                  forcePage={
                    Number(currentPage) > 0 ? Number(currentPage) - 1 : 0
                  }
                />
              </div>
            )}
          </>
        )}
      </div>

      <div className="w-full mx-auto p-6 text-left md:hidden">
        <div className="grid grid-cols-1 gap-6 ">
          {orders.map((order) => (
            <div
              key={order.orderId}
              className="bg-white rounded-lg shadow-lg transition duration-300 transform border py-2 "
            >
              <div className="flex justify-between p-3">
                <div className="text-xl font-semibold text-gray-700">
                  #{order?.order_id}
                </div>
                <button
                  className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-3 rounded-full mr-2"
                  onClick={() => detailsShow(order?.order_id)}
                >
                  <FaEye />
                </button>

              </div>
              <div className="flex items-center w-full mt-2 text-gray-600 bg-gray-100 border p-2 border-gray-300">
                <strong className="w-1/2">Customer:</strong> 
                <span className="w-1/2">{order?.name}</span>
              </div>
              <div className="flex items-center w-full text-gray-600 p-2">
                <strong className="w-1/2">Number of Products:</strong> 
                <span className="w-1/2">{order?.products}</span>
              </div>
              <div className="flex items-center w-full text-gray-600 bg-gray-100 border p-2 border-gray-300">
                <strong className="w-1/2">Status:</strong> 
                <span className="w-1/2">{order?.status_group}</span>
              </div>
              <div className="flex items-center w-full text-gray-600 p-2">
                <strong className="w-1/2">Date:</strong> 
                <span className="w-1/2">{order?.date_added}</span>
              </div>
              <div className="flex items-center w-full text-gray-600 bg-gray-100 border p-2 border-gray-300">
                <strong className="w-1/2">Total:</strong> 
                <span className="w-1/2">{order?.total}</span>
              </div>
            </div>
          ))}
        </div>
      </div>



      {showDetails && (
        <PopUp 
        isOpen={showDetails}
        onClose={() => setShowDetails(false)}
        title={`Order Id: ${details?.order_id}`}
        titleStyling="text-start font-light mb-0"
        PopUpWidth={'w-[60vh]'}
        >
          <div className="flex items-center text-sm gap-3 border-b border-gray-200 pb-3 ">
            <span className="text-gray-500">Order Details </span>
          </div>
          <div className="border-b border-gray-200">
          {Array.isArray(details?.products) && (
            details.products.map((product, index) => (
              <div className="flex flex-col gap-3" key={index}>
               <OrderProduct product={product} />
              </div>
            ))
          )}
          </div>

          <div className="flex flex-col gap-2 border-b border-gray-200">
            <OrderInfo keyText="Customer Name" value={details?.firstname + ' ' + details?.lastname} />
            <OrderInfo keyText="Phone" value={details?.telephone} />
          </div>

          <div className="flex gap-2 text-left mt-3">
          <div className="w-1/2 flex flex-col gap-1 mb-4">
            <span className=" text-dborderblack4 font-semibold">
              Payment Type
            </span>
            <span className=" text-gray-500 text-sm mt-3">
              {details?.payment_method || "Cash On Delivery"}
            </span>
          </div>


            <div className="w-1/2 flex flex-col gap-3 ">
              <span className="text-dborderblack4 font-semibold">
                Payment Summary
              </span>
              <div className="gap-2 text-sm">
                {Array.isArray(details?.totals) && (
                  details.totals.map((total, index) => (
                    <div className="flex flex-col gap-3" key={index}>
                      <div className={`flex items-center justify-between py-2  text-left ${(details.totals.length -2) === index && 'border-b-2 border-gray-200'}`}>
                          <div className=" text-gray-500 text-sm font-medium capitalize">
                              {total?.title}:
                          </div>
                          <div className=" text-gray-800 text-sm">
                            {total?.text}
                          </div>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
          

        </PopUp>
      )}
    </div>
  );
}
